import { render } from "./benefits.vue?vue&type=template&id=66d3bc6b&scoped=true"
import script from "./benefits.vue?vue&type=script&lang=js"
export * from "./benefits.vue?vue&type=script&lang=js"

import "./benefits.vue?vue&type=style&index=0&id=66d3bc6b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66d3bc6b"

export default script